import {XauditModel} from '../xaudit.model';
import {DataAppointmentModel} from './data-appointment.model';
import {AppointmentFlagDataModel} from './appointment-flag-data.model';
import {AppointmentDetailDataModel} from "./appointment-detail-data.model";

export class DataAppointmentWaitListModel extends XauditModel {
    WaitListID: string;
    AppointmentId: string;
    Description: string;
    isHandeled: boolean;
}

export class WaitListViewModel {
    AppointmentId: string;
    CaseProcedureId: string;
    PatientCaseId: string;
    CaseWorkItemId: string;
    dataAppoitmentFlags: AppointmentFlagDataModel[] = [];
    dataAppoitmentDetails: AppointmentDetailDataModel[] = [];
    enumApptStatusId: string;
    enumApptTypeId: string;
    Label_DoctorId: string;
    Resource_OperatoryId: string;
    Resource_OperatoryAId: string;
    StartDate: Date;
    EndDate: Date;
    subject: string;
    PatientId: string;
    Patient_FullName: string;
    Patient_Contact: string;
    DoctorId: string;
    Doctor_FullName: string;
    RefDoctorId: string;
    RefDoctor_FullName: string;
    WaitListId: string;
    DateWaitListed: Date;
    Description: string;


}

export class PasteReschedule {
    AppointmentId: string;
    Patient_FullName: string;
    Reschedule_note: string;
    isReschedule: boolean;

}

export class DoctorListModel {
    DoctorId: string;
    Doctor_FullName: string;
}
export class DoctorListModelV2 {
  DoctorId: string;
  DoctorFullName: string;
}
